var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.addHandovermodal = false
      }
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.is_Loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('handover.shipmenthandover')) + " ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CourierCompany),
      expression: "CourierCompany"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('CourierCompany')
    },
    attrs: {
      "name": "CourierCompany",
      "id": "CourierCompany",
      "disabled": _vm.isdisableValue
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CourierCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onchange]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyPlaceHolder')) + " ")]), _vm._v(" "), _vm._l((_vm.listCourierData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.couriername
      }
    }, [_vm._v(_vm._s(warehouse_obj.couriername))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CourierCompany')),
      expression: "errors.has('CourierCompany')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.courierCompanyError')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('handover.handoverpersonname')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HandoverPersonName),
      expression: "HandoverPersonName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HandoverPersonName')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('handover.handoverpersonPlaceholder'),
      "name": "HandoverPersonName",
      "disabled": _vm.isdisableValue,
      "id": "HandoverPersonName"
    },
    domProps: {
      "value": (_vm.HandoverPersonName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.HandoverPersonName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HandoverPersonName')),
      expression: "errors.has('HandoverPersonName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('handover.HandoverPersonNameError')) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('handover.awbno')) + " :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbno),
      expression: "awbno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbno')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('handover.awbnoPlaceholder'),
      "name": "awbno",
      "id": "awbno"
    },
    domProps: {
      "value": (_vm.awbno)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.checkinput($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbno = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbno')),
      expression: "errors.has('awbno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('supportRequest.aWBNumberError')) + "\n                ")]), _vm._v(" "), (this.errormsg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "inwardfooter form-actions float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary",
      "disabled": !_vm.isComplete1
    },
    on: {
      "click": _vm.saveHandover
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('handover.handover')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetaddDeatilsForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))]), _vm._v("  \n            ")])])], 1)])], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71823e7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71823e7c","hasScoped":true}!./src/views/components/shipmenthandover/shipmenthandover.component.html
// module id = 1819
// module chunks = 0